import _get from 'lodash/get'

import {
    PENSIONS_CONTRIBUTIONS_SAVE_ERROR,
    PENSIONS_CONTRIBUTIONS_SAVE_SUCCESS,
    PENSIONS_CONTRIBUTIONS_SAVING,
    PENSIONS_CONTRIBUTIONS_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        fetchSuccessful: null,
        goToNextQuestion: false,
        goToNextAllowanceQuestion: false,
        isAllowanceUpdate: false,
        activeQuestionIndex: 0,
    },
    action
) => {
    switch (action.type) {
        case PENSIONS_CONTRIBUTIONS_UPDATE:
            return { ...state, ...action.pensionsContributions }

        case PENSIONS_CONTRIBUTIONS_SAVING:
            return { ...state, isSaving: true }

        case PENSIONS_CONTRIBUTIONS_SAVE_SUCCESS:
            return {
                ...state,
                ...action.pensionsContributions,
                isSaving: false,
                goToNextQuestion: !action.pensionsContributions.isAllowanceUpdate,
                goToNextAllowanceQuestion: action.pensionsContributions.isAllowanceUpdate,
                isAllowanceUpdate: false,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case PENSIONS_CONTRIBUTIONS_SAVE_ERROR:
            return {
                ...state,
                ...action.pensionsContributions,
                isSaving: false,
                goToNextQuestion: false,
                goToNextAllowanceQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }

        default:
            return state
    }
}
